export const pathJoin = (...paths) =>
  paths
    .map(p => (p || '').replace(/^[/]*(.*[^/])?.*$/, '$1'))
    .filter(i => i)
    .join('/');

export const rootPathJoin = (...paths) => `/${pathJoin(...paths)}`;

export const languagePathJoin = (language, ...paths) =>
  `/${language}/${pathJoin(...paths)}`;

export const normalizePath = (language, to) =>
  typeof to === 'object'
    ? { ...to, pathname: languagePathJoin(language, to.pathname) }
    : languagePathJoin(language, to || '');

export const prepareAnchors = (language, anchors) =>
  Object.keys(anchors).reduce(
    (result, key) => ({
      ...result,
      [key]: languagePathJoin(language, anchors[key][language]),
    }),
    {}
  );



// WEBPACK FOOTER //
// ./src/common/methods/language.js